module.exports = __webpack_public_path__ + "static/img/0754.9e42290.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0754.jpg
// module id = 93
// module chunks = 0